import { IField } from 'src/types/DTO/field/IField';
import { IFieldBrief } from 'src/types/DTO/field/IFieldBrief';

export const toFields = (data: any): IField[] => data?.map((item: any) => toField(item));

export const toField = (item: any): IField => ({
  id: item?.id,
  name: item?.fieldName,
  code: item?.fieldCode,
  description: item?.fieldDes,
  createdAt: item?.createdAt,
});

export const toFieldBrief = (field: any): IFieldBrief => ({
  id: field?.fieldId,
  name: field?.fieldName,
});

export const toFieldBriefs = (data: any): IFieldBrief[] =>
  data?.map((item: any) => toFieldBrief(item));
